import { Event } from "../../contracts";
import { Market } from "sbtech-sports-data-api-contracts";
import { getEachWayTitle } from "../getEachWayTitle";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const getEventTitle = (event: Event, market: Market, eachWayString: string) => {
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()) {
        let placeTerm = parseInt(market.metadata.placeTermsId);
        let oddsTerms= parseInt(market.metadata.oddsTermsId);

        const eachWay = oddsTerms && placeTerm
                ? getEachWayTitle(eachWayString, placeTerm, oddsTerms)
                : "";
        return `${event.eventName} ${eachWay} ${event.eventDate} | ${event.eventTime}`;
    }

    return event.eventName;
}